export function concatenarEndereco(endereco) {
	if(!endereco) {
		return ''
	}

	return `${endereco.rua}, ${endereco.numero || 'S/N'}${endereco.complemento ? ` - ${endereco.complemento}` : ''} - ${endereco.bairro} - ${endereco.uf} - ${endereco.cidade} - ${endereco.cep}`
}